import React, { useEffect, useMemo, useState } from 'react';
import { Table, Skeleton, Tag } from 'antd';
import FeedbackDetailTableStatistic from './FeedbackDetailTableStatistic';
import formService from '../../../services/formService';
import CourseObj from '../../../objects/courseType';

const sortCourseTypes = (items) =>
  [...items].sort((a, b) => Number(a.weight || 0) - Number(b.weight || 0));

const getCachedCourseTypes = () => {
  try {
    const cache = localStorage.getItem('COURSE_TYPE_LIST');
    return cache ? sortCourseTypes(JSON.parse(cache)) : CourseObj.courseType;
  } catch (error) {
    return CourseObj.courseType;
  }
};

const renderCourseType = (courseType, courseTypes) => {
  const normalizedCourseType = courseType === 'LECTURE' ? 'MIN60' : courseType;
  const target = courseTypes.find((item) => item.type === normalizedCourseType);
  if (target) {
    return <Tag color={target.color || 'green'}>{target.name}</Tag>;
  }
  return normalizedCourseType ? (
    <Tag color='green'>{normalizedCourseType}</Tag>
  ) : null;
};

const FeedbackDetailTable = (props) => {
  const {
    isLoading,
    search,
    feedbackDetailList,
    feedbackDetailTotal,
    isFeedbackDelete,
    setIsFeedbackDelete,
    columns,
    pagination,
    setPagination,
    courseList,
    getQuery,
    form,
  } = props;
  const [courseTypes, setCourseTypes] = useState(getCachedCourseTypes);

  useEffect(() => {
    formService
      .queryCourseType(true)
      .then((res) => {
        const data = sortCourseTypes(res.data || []);
        setCourseTypes(data);
      })
      .catch(() => setCourseTypes(getCachedCourseTypes()));
  }, []);

  useEffect(() => {
    let query = getQuery(form.getFieldValue(), courseList);
    search(pagination.current, pagination.pageSize, query);
  }, [pagination]);

  useEffect(() => {
    if (isFeedbackDelete) {
      setIsFeedbackDelete(false);
      window.location.reload();
    }
  }, [isFeedbackDelete]);

  const handleTableChange = ({ current, pageSize, total }) => {
    console.log(
      'pagination & total in feedback detail table: ',
      pagination,
      total
    );
    setPagination({ current, pageSize });
  };

  const displayColumns = useMemo(() => {
    return (columns || []).map((column) => {
      if (column.dataIndex !== 'courseType') {
        return column;
      }
      return {
        ...column,
        render: (courseType) => renderCourseType(courseType, courseTypes),
      };
    });
  }, [columns, courseTypes]);

  return isLoading ? (
    <Skeleton active />
  ) : (
    <Table
      dataSource={feedbackDetailList}
      columns={displayColumns}
      pagination={{
        ...pagination,
        total: feedbackDetailTotal,
        position: ['topLeft'],
      }}
      onChange={handleTableChange}
      summary={(pageData) => {
        // console.log('page data is: ', pageData);
        return (
          <FeedbackDetailTableStatistic
            feedbackStatistic={feedbackDetailTotal}
          />
        );
      }}
    />
  );
};

export default FeedbackDetailTable;
